import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function ChatLoading() {
  return (
    <div style={{display:"flex", flexDirection:"column", alignItems:"flex-end"}}>
      <SkeletonTheme
        baseColor="#cfd2d5"
        highlightColor="#ffffff"
        width={100}
        borderRadius={50}
        height={30}
        duration={1.5}
      >
        <p>
          <Skeleton count={3} />
        </p>
      </SkeletonTheme>
    </div>
  );
}
